import pegasus from "./00-pegasus";

window.initUserAccount = () => {
    return {
        baseURL: userAccountBase,
        loggedIn: false,
        userType: null,
        updateUi() {
            const jobListingId = document.querySelectorAll('[data-job-listing-id]');
            let jobListings = null;

            pegasus.fetchContent(`${this.baseURL}/api/employers/me/auth`, {
                credentials: 'include',
                headers: {
                    Accept: "application/json",
                }
            }).then(async resp => {
                if(resp.ok){
                    this.loggedIn = true;
                    this.userType = 'employer';
                    this.swapNavButton();
                } else {
                    const buttonLoader = document.getElementById('navigation-buttons-loading');
                    setTimeout(() => {
                        buttonLoader.remove();
                    }, 300);
                }
            }).catch(err => {
                //We don't care about errors here because production laravel will throw a 500 error if unauthenticated
                const buttonLoader = document.getElementById('navigation-buttons-loading');
                setTimeout(() => {
                    buttonLoader.remove();
                }, 300);
                console.log(err)
            })

            if(this.loggedIn === false || this.userType === 'candidate'){
                pegasus.fetchContent(`${this.baseURL}/api/candidates/me/saved-jobs`, {
                    credentials: 'include',
                    headers: {
                        Accept: "application/json",
                    }
                }).then(async resp => {
                    if(resp.ok){
                        jobListings = await resp.json();
                        this.loggedIn = true;
                        this.userType = 'candidate';
                        this.swapNavButton();
                        if(typeof jobListings !== 'undefined' && jobListings !== null){

                            if(jobListings !== null){
                                jobListingId.forEach(elem => {
                                    this.checkSavedJobs(jobListings, elem);
                                });
                            }
                        }
                    } else {
                        jobListingId.forEach(elem => {
                            this.updateFavourite(elem, false);
                        });

                        const buttonLoader = document.getElementById('navigation-buttons-loading');
                        buttonLoader.remove();
                    }
                }).catch(err => {
                    //We don't care about errors here because production laravel will throw a 500 error if unauthenticated
                    const buttonLoader = document.getElementById('navigation-buttons-loading');
                    setTimeout(() => {
                        buttonLoader.remove();
                    }, 300);
                    console.log(err)
                })
            }
        },
        swapNavButton(){
            const buttonContainer = document.getElementById('navigation-buttons');
            let accountLink = null;
            if(this.userType === 'candidate'){
                accountLink = '/candidate/dashboard';
            } else if(this.userType === 'employer'){    
                accountLink = '/employer/dashboard';
            }
            buttonContainer.innerHTML = '<a href="' + this.baseURL + accountLink +'" class=" text-link mx-2 my-2 my-account-link"><span>My account</span></a>';
            
            const buttonLoader = document.getElementById('navigation-buttons-loading');
            setTimeout(() => {
                buttonLoader.remove();
            }, 300);
            
        },
        checkSavedJobs(data, elem) {
            const jobId = elem.dataset.jobListingId;
            let isFavourited = false;
            for(let i = 0; i<data.data.length; i++){
                if(data.data[i].id === parseInt(jobId)){
                    isFavourited = true;
                }
            }

            this.updateFavourite(elem, isFavourited);
        },
        updateFavourite(elem, favourited = false){
            const favouriteLink = elem.querySelector('.Save__Link');
            const alreadyFavouritedLink = elem.querySelector('.Save__Link.Saved');

            if(favourited){
                favouriteLink.classList.add('hidden');
                alreadyFavouritedLink.classList.remove('hidden');
            } else {
                favouriteLink.classList.remove('hidden');
                alreadyFavouritedLink.classList.add('hidden');
            }
        },
        updateJobStatus(event, jobId, method = 'POST'){
            const XSRFToken = pegasus.getCookie('XSRF-TOKEN');

            let endpoint = `${this.baseURL}/api/candidates/me/saved-jobs`;

            if(method === 'DELETE'){
                endpoint = `${this.baseURL}/api/candidates/me/saved-jobs/${jobId}`;
            }

            pegasus.fetchContent(endpoint, {
                method: method,
                credentials: 'include',
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Accept": "application/json, text/plain, */*",
                    "X-XSRF-TOKEN": XSRFToken,
                },
                body: 'id='+jobId,
            }).then(async resp => {
    
                if(resp.ok){
                    const buttonContainer = event.closest('.Save__Link');
                    const jobContainer = event.closest('.Single__Job');
                    const otherButtonContainer = jobContainer.querySelector('.Save__Link.hidden');
                    const savedMessage = otherButtonContainer.querySelector('.success__tooltip');

                    savedMessage.classList.remove('opacity-0');
                    savedMessage.classList.add('opacity-100');

                    buttonContainer.classList.add('hidden');
                    otherButtonContainer.classList.remove('hidden');

                    setTimeout(() => {
                        savedMessage.classList.add('opacity-0');
                        savedMessage.classList.remove('opacity-100');
                    }, 3000)

                } else {
                    window.location.href = this.baseURL + '/candidate/login';
                }
                
            }).catch(err => console.log(err))
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const button = document.querySelector('.sticky-enquiry-button');
    const initialPosition = 200;

    function updateButtonPosition() {
        const isMobile = window.innerWidth <= 768;
        const bottomPosition = isMobile ? '40px' : '90px';

        document.addEventListener('scroll', () => {
            if (window.scrollY > initialPosition) {
                button.classList.remove('translate-y-[200px]');
                button.style.bottom = bottomPosition;
            } else {
                button.classList.add('translate-y-[200px]');
                button.style.bottom = '-150px';
            }
        });
    }

    // Run on load
    updateButtonPosition();

    // Re-check if the screen size changes (e.g., resizing the browser)
    window.addEventListener('resize', updateButtonPosition);
});


window.initPageFunctions = () => {
    window.initUserAccount().updateUi();
}

window.onload = window.initPageFunctions;